import React, { useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import './Menu.scss';
import { Link } from 'react-router-dom';
import Icon from '../Icon';
import * as urls from 'constants/urls';
import { getMatrix } from 'constants/matrices';

export const MatrixMenuName = ({ matrix, children }) => {
  const matrices = useSelector(state => state.matrices.matrices);

  const baseMatrix = useMemo(() => getMatrix(matrices, matrix?.parentId), [
    matrix,
    matrices,
  ]);

  const baseMatrixUrl = baseMatrix ? urls.matrix(baseMatrix) : null;

  const matrixName = useMemo(() => {
    return (baseMatrix ?? matrix)?.name;
  }, [baseMatrix, matrix]);

  const experimentName = useMemo(() => {
    return matrix?.parentId ? matrix?.name : null;
  }, [matrix]);

  return (
    <div className="Menu-name">
      {experimentName ? (
        <Link to={baseMatrixUrl} className="Menu-name-secondary">
          {matrixName}
        </Link>
      ) : (
        <div className="Menu-name-primary">{matrixName}</div>
      )}
      {experimentName ? (
        <>
          <Icon alt={'rightCaret'} icon={'rightCaret'} className="Menu-caret" />
          <div className="Menu-name-primary">{experimentName}</div>
        </>
      ) : null}
      {children}
    </div>
  );
};

export const GalleryMenuName = ({ folderName, isEducation, onClick }) => {
  return (
    <div className="Menu-name">
      {folderName ? (
        onClick ? (
          <div onClick={onClick} className="Menu-name-secondary">
            Matrix Gallery
          </div>
        ) : (
          <Link to={urls.gallery()} className="Menu-name-secondary">
            Matrix Gallery
          </Link>
        )
      ) : (
        <div className="Menu-name-primary">Matrix Gallery</div>
      )}

      {isEducation ? (
        <div className="Menu-caret-container">
          <Icon alt={'rightCaret'} icon={'rightCaret'} className="Menu-caret" />
          <div className="Menu-name-secondary" onClick={onClick}>
            {'Public'}
          </div>
        </div>
      ) : null}

      {folderName ? (
        <div className="Menu-caret-container">
          <Icon alt={'rightCaret'} icon={'rightCaret'} className="Menu-caret" />
          <div className="Menu-name-primary">{folderName}</div>
        </div>
      ) : null}
    </div>
  );
};

export const MenuDescription = ({ description }) => (
  <div className="Menu-description">{description}</div>
);

export const MenuText = ({ children }) => (
  <div className="Menu-text">{children}</div>
);

export const MenuActions = ({ children, className }) => (
  <div className={classNames('Menu-actions', className)}>{children}</div>
);

export const Menu = ({ children, className }) => (
  <div className={classNames('Menu', className)}>{children}</div>
);

export const MenuSection = ({ children }) => (
  <div className="Menu-section">{children}</div>
);
